export default [
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Referral',
    },
    cell: {
      type: 'slot',
      name: 'referral',
    },
  },
  {
    width: 15,
    header: {
      type: 'text',
      caption: 'Date of lead assignment',
      sort: 'createdAt',
    },
    cell: {
      type: 'slot',
      name: 'dateOfLeadAssignment',
    },
  },
  {
    width: 15,
    header: {
      type: 'text',
      caption: 'Percents',
    },
    cell: {
      type: 'slot',
      name: 'percents',
    },
  },
  {
    width: 5,
    header: {
      type: 'text',
      caption: '',
    },
    cell: {
      type: 'slot',
      name: 'controls',
    },
  },
];
